import localStorage from '@/utils/localStorage';
import API from "@/api";

const thirdLoginPtids = ['maycur', 'ksxjdx', 'cmblife'];
let ptid = localStorage.get('ptid');
let entryUrlParsed = localStorage.get('entryUrlParsed') || '';

function checkNeedThirdLogin() {
  return thirdLoginPtids.indexOf(ptid) > -1;
}

function thirdLogin() {
  return Promise.resolve().then(() => {
    if (ptid === "maycur") {
      if (entryUrlParsed && entryUrlParsed.phone) {
        return API.login["331623"]({
          passengerMobile: entryUrlParsed.phone,
          maycurSignValue: entryUrlParsed.mid || '',
          timestamp: entryUrlParsed.timestamp || ''
        }).then(r => {
          if (r && r.authcode) {
            localStorage.set('authcode', r.authcode);
            return;
          } else {
            throw {
              type: "PHONECODE_LOGIN"
            };
          }
        })
      } else {
        throw {
          type: "PHONECODE_LOGIN"
        };
      }
    } else if (ptid ==='ksxjdx') {
      // http://xjyijiyoutest.shanvisa.cn:50002/dist/#/login?backurl=https://h5.133.cn/hangban/vue/oauth2/callback/ksxjdx?ru=https://hotel.rsscc.cn/indexVue.html#/orderList?hlsource=ksxjdx
      const baseUrl = 'http://xjyijiyoutest.shanvisa.cn:50002/dist/#/login'
      const ru = location.origin + location.pathname + '?ptid=' + ptid
      const backurl = `https://h5.133.cn/hangban/vue/oauth2/callback/ksxjdx?ru=${encodeURIComponent(ru)}&type=1`
      const url = `${baseUrl}?backurl=${encodeURIComponent(backurl)}`;
      window.location.href = url;
      throw { type: 'KSXJDX_LOGIN' };

    } else if(ptid ==='cmblife') {

      const baseUrl = 'https://wtest.133.cn/hangban/vue/thirdparty/cmblife-auth?hlsource=cmblife&type=1';
      const ru = location.href
      const url = `${baseUrl}&ru=${encodeURIComponent(ru)}`;
      window.location.href = url;
      throw { type: 'CMBLIFE_LOGIN' };

    } else {
      throw {
        type: "PHONECODE_LOGIN"
      };
    }
  });
}

export default {
  checkNeedThirdLogin,
  thirdLogin
}



// WEBPACK FOOTER //
// ./src/auth/thirdLogin.js